import http from '@/utils/http';

export default {
	billList: data => http({ url: '/api/admin/v1/finance/billList', data }),
	billDetail: data => http({ url: '/api/admin/v1/finance/billDetail', data }),
	settlementList: data => http({ url: '/api/admin/v1/finance/settlementList', data }),
	settlementAvailableOrders: data => http({ url: '/api/admin/v1/settlement/availableOrders', data }),
	settlementCreateManual: data => http({ url: '/api/admin/v1/settlement/createManual', data, tip: true }),
	settlementReminders: data => http({ url: '/api/admin/v1/settlement/reminders', data }),
	settlementVoidManual: data => http({ url: '/api/admin/v1/settlement/voidManual', data, tip: true }),
	settlementDetail: data => http({ url: '/api/admin/v1/settlement/detail', data }),
	settlementExportStatement: data => http({ url: '/api/admin/v1/settlement/exportStatement', data }),
	settlementExportOrders: data => http({ url: '/api/admin/v1/settlement/exportOrders', data }),
	statistics: data => http({ url: '/api/admin/v1/finance/statistics', data }),
	businessStatistics: data => http({ url: '/api/admin/v1/finance/businessStatistics', data }),
	financeDashboard: data => http({ url: '/api/admin/v1/finance/financeDashboard', data }),
	financeDashboardCompanyOptions: data => http({ url: '/api/admin/v1/finance/financeDashboardCompanyOptions', data }),
	payoutList: data => http({ url: '/api/admin/v1/finance/payoutList', data }),
	payoutDetail: data => http({ url: '/api/admin/v1/finance/payoutDetail', data }),
	confirmPayout: data => http({ url: '/api/admin/v1/finance/confirmPayout', data, tip: true }),
	export: data => http({ url: '/api/admin/v1/finance/export', data }),
};
